var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.663 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.541 3.091a2.834 2.834 0 0 0-2.7-2.96C13.821.036 11.762 0 9.658 0H9C6.9 0 4.837.036 2.817.131A2.84 2.84 0 0 0 .127 3.1C.036 4.4 0 5.694 0 6.992s.036 2.6.124 3.9a2.843 2.843 0 0 0 2.694 2.971c2.122.1 4.3.142 6.511.139s4.386-.036 6.511-.139a2.844 2.844 0 0 0 2.7-2.971c.087-1.3.128-2.6.124-3.9s-.035-2.599-.123-3.901Zm-11 7.477V3.405l5.286 3.58Z"
  })));
};

export default SvgYoutube;